import { useState } from 'react';
import { API_URL } from '../utils/constant';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const TallySyncButton = () => {
    const [syncing, setSyncing] = useState(false);
    const [syncProgress, setSyncProgress] = useState('');
    const navigate = useNavigate();

    const syncWithTally = async () => {
        try {
            setSyncing(true);
            const companyID = localStorage.getItem('companyID');
            const BASE_URL = `${API_URL}/tally`;

            const apis = [
                { name: 'Tax & Cash Ledgers', url: `${BASE_URL}/ledgers/${companyID}` },
                { name: 'Suppliers', url: `${BASE_URL}/suppliers/${companyID}` },
                { name: 'Customers', url: `${BASE_URL}/customers/${companyID}` },
                { name: 'Stock Items', url: `${BASE_URL}/stock-items/${companyID}` },
                { name: 'Purchase Vouchers', url: `${BASE_URL}/purchase-vouchers/${companyID}` },
                { name: 'Sales Vouchers', url: `${BASE_URL}/sales-vouchers/${companyID}` },
                { name: 'Supplier Payments', url: `${BASE_URL}/supplier-payments/${companyID}` },
                { name: 'Expense Vouchers', url: `${BASE_URL}/expense-vouchers/${companyID}` },
            ];

            let syncedCount = 0;
            for (const api of apis) {
                setSyncProgress(`Syncing ${api.name}...`);
                console.log(`🔄 Syncing ${api.name}...`);

                const res = await axios.post(api.url, {
                    mode: 'sync'
                });

                if (res.status !== 200 && res.status !== 201) {
                    throw new Error(`${api.name} sync failed: ${res.data?.error || res.statusText}`);
                }
                syncedCount++;
            }

            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Tally Sync Completed Successfully',
                text: `All ${syncedCount} modules synced with Tally Prime`,
                showConfirmButton: false,
                timer: 3500,
                timerProgressBar: true,
            });

        } catch (err) {
            const errorMsg = err.response?.data?.error || err.response?.data?.message || err.message || 'Tally Sync Failed';
            Swal.fire({
                toast: false,
                position: 'center',
                icon: 'error',
                title: 'Tally Sync Failed',
                text: errorMsg,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Check Tally Guide',
                cancelButtonText: 'Close',
                showCloseButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/tally/guide');
                }
            });

        } finally {
            setSyncing(false);
            setSyncProgress('');
        }
    };

    return (
        <li className="nav-item pos-nav">
            <button
                onClick={syncWithTally}
                className="btn btn-primary btn-md d-inline-flex align-items-center"
                disabled={syncing}
                title={syncProgress || 'Sync all ledgers, stock, purchases, sales and payments with Tally'}
            >
                <i
                    className={`ti ${syncing ? 'ti-loader-2 spin' : 'ti-refresh'} me-1`}
                />
                <span className="tally-sync-full">{syncing ? (syncProgress || 'Syncing…') : 'Sync with Tally'}</span>
                <span className="tally-sync-compact d-none">{syncing ? 'Syncing…' : 'Sync'}</span>
            </button>
        </li>
    );
};

export default TallySyncButton;
